import _slicedToArray from "D:\\WORK\\projects\\szn-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import * as React from 'react';
import useScript from 'react-script-hook';
function useRecaptcha(_ref) {
  var sitekey = _ref.sitekey,
    _ref$hideDefaultBadge = _ref.hideDefaultBadge,
    hideDefaultBadge = _ref$hideDefaultBadge === void 0 ? false : _ref$hideDefaultBadge,
    _ref$checkForExisting = _ref.checkForExisting,
    checkForExisting = _ref$checkForExisting === void 0 ? true : _ref$checkForExisting;
  var _React$useState = React.useState(),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    recaptcha = _React$useState2[0],
    setRecaptcha = _React$useState2[1];
  React.useEffect(function () {
    if (isBrowser && hideDefaultBadge) {
      injectStyle('.grecaptcha-badge { visibility: hidden; }');
    }
  }, [hideDefaultBadge]);
  useScript({
    src: "https://www.google.com/recaptcha/api.js?render=".concat(sitekey),
    onload: function onload() {
      return window.grecaptcha.ready(function () {
        setRecaptcha(window.grecaptcha);
      });
    },
    checkForExisting
  });
  React.useEffect(function () {
    if (window.grecaptcha) {
      window.grecaptcha.ready(function () {
        setRecaptcha(window.grecaptcha);
      });
    }
  }, []);
  return function (action) {
    return new Promise(function (resolve, reject) {
      if (recaptcha) {
        resolve(recaptcha.execute(sitekey, {
          action
        }));
      } else {
        reject(new Error('Recaptcha script not available'));
      }
    });
  };
}
var isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';
var injectStyle = function injectStyle(rule) {
  var styleEl = document.createElement('style');
  document.head.appendChild(styleEl);
  var styleSheet = styleEl.sheet;
  if (styleSheet) styleSheet.insertRule(rule, styleSheet.cssRules.length);
};
var Badge = function Badge(props) {
  return /*#__PURE__*/React.createElement("span", props, "This site is protected by reCAPTCHA and the Google", ' ', /*#__PURE__*/React.createElement("a", {
    href: "https://policies.google.com/privacy",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Privacy Policy"), ' ', "and", ' ', /*#__PURE__*/React.createElement("a", {
    href: "https://policies.google.com/terms",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Terms of Service"), ' ', "apply.");
};
export { Badge, useRecaptcha };